import { useState, useEffect } from 'react';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0f1a14] border-b border-[#c9a84c]/20' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <div className="flex flex-col leading-tight">
          <span className="text-lg font-bold tracking-wide text-[#c9a84c]">
            猎鹰定位找人
          </span>
          <span className={`text-xs ${scrolled ? 'text-[#c9a84c]/60' : 'text-white/70'}`}>
            专业调查 · 全程保密 · 高效服务
          </span>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: '首页', href: '/' },
            { label: '服务项目', href: '#services' },
            { label: '案例展示', href: '#cases' },
            { label: '关于我们', href: '#about' },
            { label: '服务网络', href: '#provinces' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className={`text-sm font-medium transition-colors hover:text-[#c9a84c] whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-white/80' : 'text-white/90'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="bg-[#c9a84c] hover:bg-[#b8963e] text-[#0f1a14] text-sm font-bold px-5 py-2 rounded-md whitespace-nowrap cursor-pointer transition-colors"
          >
            免费咨询
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl text-[#c9a84c]`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0f1a14] border-t border-[#c9a84c]/20 px-4 py-4 flex flex-col gap-3">
          {[
            { label: '首页', href: '/' },
            { label: '服务项目', href: '#services' },
            { label: '案例展示', href: '#cases' },
            { label: '关于我们', href: '#about' },
            { label: '服务网络', href: '#provinces' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm text-white/80 font-medium py-1 cursor-pointer hover:text-[#c9a84c]"
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="bg-[#c9a84c] text-[#0f1a14] text-sm font-bold px-4 py-2 rounded-md text-center whitespace-nowrap cursor-pointer"
            onClick={() => setMenuOpen(false)}
          >
            免费咨询
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
